var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { BaseButton, PrimaryText, Title } from "../../../designSystem";
import colors from "../../../designSystem/colors";
import theme from "../../../designSystem/theme";
var Descritpion = styled(PrimaryText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 8px;\n  color: ", ";\n"], ["\n  margin-top: 8px;\n  color: ", ";\n"])), colors.text);
var ClearButton = styled(BaseButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 24px;\n  padding: 14px 24px;\n  background: ", "29;\n  border-radius: ", ";\n\n  &:hover {\n    opacity: ", ";\n  }\n"], ["\n  margin-top: 24px;\n  padding: 14px 24px;\n  background: ", "29;\n  border-radius: ", ";\n\n  &:hover {\n    opacity: ", ";\n  }\n"])), colors.primaryText, theme.border.radius, theme.hover.opacity);
var ClearButtonText = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 1px;\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 1px;\n"])));
var EmptyResult = function (_a) {
    var setFilterStrategies = _a.setFilterStrategies, setFilterAssets = _a.setFilterAssets, props = __rest(_a, ["setFilterStrategies", "setFilterAssets"]);
    return (_jsxs("div", __assign({}, props, { className: "w-100 h-100 d-flex flex-column align-items-center justify-content-center flex-wrap " + props.className }, { children: [_jsx(Title, __assign({ fontSize: 18, lineHeight: 24 }, { children: "NO RESULTS" }), void 0), _jsx(Descritpion, { children: "Pleas try adjusting your filters." }, void 0)] }), void 0));
};
export default EmptyResult;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=EmptyResult.js.map